import classNames from 'classnames';
import { ModuleLoad } from 'layout/module-load/module-load.js';
import * as React from 'react';
import { ModulePropsCore } from 'redux-state/layout/types.slots.js';
import { formatUrlSlug } from 'utilities/slugify.js';

export const SecondaryLargeModules = React.memo(function WrapModules({
  moduleConfigArr = [],
  modulePath,
}: ModulePropsCore) {
  return (
    <>
      {moduleConfigArr.map((config, index) => {
        const { name } = config;
        const key = `${name}${index}`;
        const isLast = index === moduleConfigArr.length - 1;
        return (
          <div
            key={key}
            data-slug={formatUrlSlug(config)}
            className={classNames({ 'u-mB-responsive': !isLast })}
            role="presentation"
            data-module-lookup={config.name}
          >
            <ModuleLoad config={config} modulePath={modulePath} />
          </div>
        );
      })}
    </>
  );
});
